import Tab from 'bootstrap/js/dist/tab'

const $ = window.jQuery

// Funzione per generare una stringa casuale di lunghezza specificata
function generateRandomString(length) {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

const init = function() {
  var tabs = $(".wp-block-getwid-tabs:not(.c24-getwid-init)");
      
  tabs.each(function () {
    var $this = $(this);
    var randomId = generateRandomString(5);
    var activeTabIndex = $this.data("active-tab") || 0;

    $this.addClass("c24-getwid-init");

    // Aggiorna gli href dei link nella navigazione
    $this.find(".wp-block-getwid-tabs__nav-link").each(function (index, element) {
      $(element).find("button")
      .addClass('btn')
      .attr('id', 'tab-' + randomId + '-' + index)
      .attr('data-bs-target', '#' + randomId + '-' + index)
      .attr('type', 'button')
      .attr('role', 'tab')
      .attr('aria-controls', randomId + '-' + index)
    });

    // Riordina i link della navigazione
    const navLinks = $this.find(".wp-block-getwid-tabs__nav-links");
    navLinks
    .attr('role', 'tablist')
    .attr('id', 'tabs-' + randomId)
    $this.find(".wp-block-getwid-tabs__nav-link").each(function (index, element) {
      const attributes = {role:'presentation', class: 'nav-item'};
      $(element).detach();
      navLinks.append($("<li/>", attributes).append($(element).find('.wp-block-getwid-tabs__title-wrapper').contents()));
    });
    navLinks.after('<div class="tab-content"></div>')
    // Assegna gli ID ai contenuti dei tab
    const tabcontent = $this.find('.tab-content')

    $this.find(".wp-block-getwid-tabs__tab-content-wrapper")
      .each(function (index, element) {
        $(element).find('.wp-block-getwid-tabs__tab-content')
        .attr("id", randomId + "-" + index)
        .attr('role', 'tabpanel')
        .attr('aria-labelledby', 'tab-' + randomId + '-' + index)
        .addClass('tab-pane fade')
        $(element).detach();
        tabcontent.append($(element).contents());
      });

    const triggerTabList = document.querySelectorAll('#tabs-' + randomId + ' button[role="tab"]')
    triggerTabList.forEach(function (triggerEl) {
      const tabTrigger = new Tab(triggerEl)

      triggerEl.addEventListener('click', function (event) {
        event.preventDefault()
        tabTrigger.show()
      })

      /*
      * trigger carousel refresh on jqueryui tabsactivate 
      * to wait carousel initialization
      */
      triggerEl.addEventListener('shown.bs.tab', function (event) {
        /*
        event.target // newly activated tab
        event.relatedTarget // previous active tab
        */
        const $targetPanel = $(event.target.getAttribute('data-bs-target'))
        if($targetPanel.length) {
        setTimeout(()=>{
          $targetPanel.find('.slick-slider').slick('slickSetOption', 'autoplay', false, true)
        }, 100);
        }
      })
    })
    const triggerFirstTabEl = triggerTabList[activeTabIndex]
    Tab.getInstance(triggerFirstTabEl).show()
  });

}

const destroy = function() {
  
}

export default {init, destroy}